import { useEffect } from 'react';

/**
 * Meta (Facebook) Pixel component
 * Loads only on production (app.pollbolt.com)
 */
const META_PIXEL_ID = '4157505481172032';

const MetaPixel = () => {
  useEffect(() => {
    // Only load on production (app.pollbolt.com)
    const isProduction = window.location.hostname === 'app.pollbolt.com';
    
    if (!isProduction) {
      return;
    }

    // Check if pixel is already loaded
    if (window.fbq) {
      return;
    }

    // Meta Pixel base code
    (function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    // Initialize pixel
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');

  }, []);

  // Noscript fallback for users with JavaScript disabled (production only)
  const isProduction = typeof window !== 'undefined' && window.location.hostname === 'app.pollbolt.com';
  
  if (!isProduction) {
    return null;
  }

  return (
    <noscript>
      <img 
        height="1" 
        width="1" 
        style={{ display: 'none' }}
        src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
        alt=""
      />
    </noscript>
  );
};

export default MetaPixel;

